import React, { Fragment, useEffect, useState } from 'react';
import { Route, Routes, Navigate, useLocation } from 'react-router-dom';
import { VerticalLinkGroup, Breadcrumbs } from 'components/navigation';
import { PageRestricted } from 'pages/errors/page-restricted';
import { UserAccess, UserHasAccess } from 'components/user-access'; 
import { CheckSettingsSettings } from './settings';
import { CheckSettingsChangelog } from './changelog';

export function CheckSettings(props) {
    const [currentRoute, setCurrentRoute] = useState([]);

    const userCanAccessCheckSettings = UserHasAccess("Checks:Manage");

    var defaultPath;

    var routes = [];

    if (userCanAccessCheckSettings) {
        routes.push({ location: "/checks/settings/settings", title: "Settings" });
        defaultPath = (defaultPath == null) ? "/checks/settings/settings" : defaultPath;
        
        routes.push({ location: "/checks/settings/history", title: "History" });
        defaultPath = (defaultPath == null) ? "/checks/settings/history" : defaultPath;
    }

    var location = useLocation();

    useEffect(findCurrentRoute, [location]);

    function findCurrentRoute() {
        const result = routes.find((l) => {
            return location.pathname.startsWith(l.location);
        });

        setCurrentRoute([result]);
    }

    return (
        <UserAccess perform={["Checks:Manage"]}
            yes={() => (
                <Fragment>
                    <div className="row">
                        <Breadcrumbs items={props.breadcrumbs.concat(currentRoute)} />
                        <h1>Check Settings</h1>
                    </div>

                    <div className="layout-cols">
                        <div className="col side-col">
                            <div className="row">
                                <VerticalLinkGroup links={routes} exactRouteMatch={false}></VerticalLinkGroup>
                            </div>
                        </div>
                        <div className="col content-col">
                            <Routes>
                                <Route path="settings" element={<CheckSettingsSettings></CheckSettingsSettings>} />
                                <Route path="history" element={<CheckSettingsChangelog></CheckSettingsChangelog>} />
                                <Route path="" element={<Navigate to={defaultPath} replace />} />
                            </Routes>
                        </div>
                    </div>
                </Fragment>
            )}
            no={() => (
                <PageRestricted />
            )}
        />
    );
}